<script>
	import { secondsTick } from '@/Stores/Store.js';

	export let pollFunction;
	export let condition = true;
	export let frequency = 60;
	export let pollOnStart = false;

	let lastPoll = new Date().valueOf();
	let delay = 3;
	let waiting = false;

	$: $secondsTick - lastPoll > (frequency - delay) * 1000 && condition && !waiting && pollAttempt();

	const promisePollFunction = () => {
		return new Promise((resolve) => {
			pollFunction();
			resolve();
		});
	};

	/**
	 * We need to use a delay to account for when you resume the
	 * computer from sleep. We need time for the network to come back.
	 * This has been the most efficient method.
	 * window.navigator.onLine & listeners is not reliable.
	 */
	const pollAttempt = () => {
		if (!navigator.onLine) return;

		waiting = true;
		setTimeout(async () => {
			execPoll();
			waiting = false;
		}, delay * 1000);
	};

	const execPoll = async () => {
		await promisePollFunction();
		lastPoll = $secondsTick;
	};

	if (pollOnStart) execPoll();
</script>
